import { Model } from 'backbone';

export class MatchStatsCore extends Model {
	get match_stats_headings() {
		return []
	}

	initialize() {
		this.setRoundId(1);
		this.prefix = 'nrl/';
	}

	setRoundId(round_id) {
		this.url = `stats/${round_id}.json`;
	}
}

export default MatchStatsCore;